import React, {ReactNode} from "react"
import {Meta} from "~/common/components/meta"
import {Wrapper} from "~/common/components/templates/wrapper"
import {useObserverClassSetter} from "~/common/hooks/useObserverClassSetter"
import {Footer} from "../page-footer"

type Props = {
  title: string
  darkTheme?: boolean
  children: ReactNode
}

export const Page = ({children, title: pageTitle, darkTheme}: Props) => {
  const observedEl = useObserverClassSetter()

  return (
    <Meta title={pageTitle}>
      <Wrapper className={darkTheme ? "bgn-black" : undefined}>
        {children}
        <Footer useSeparator={darkTheme} />
      </Wrapper>
      {observedEl}
    </Meta>
  )
}
